module.exports = __webpack_public_path__ + "static/media/matilde-special-crown-thinking.7a2d8ff7.png";